<template>
    <div>
        <vue-gallery :images="getImages" :index="index" @close="index = null"></vue-gallery>
        <div
                class="image"
                v-for="(image, imageIndex) in getImages"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + image + ')', width: '250px', height: '200px' }"
        ></div>
    </div>
</template>

<script>
    import VueGallery from 'vue-gallery';

    export default {
        data: function () {
            return {
                imagesLocal: [
                    'https://dummyimage.com/800/ffffff/000000',
                    'https://dummyimage.com/1600/ffffff/000000',
                    'https://dummyimage.com/1280/000000/ffffff',
                    'https://dummyimage.com/400/000000/ffffff',
                ],
                index: null,

            };
        },

        props: {images: String},

        components: {
            'vue-gallery': VueGallery
        },
        computed: {
            getImages: function () {
                return JSON.parse(this.images);
            }
        },
    }
</script>

<style scoped>
    .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
</style>